import _typeof from "@babel/runtime/helpers/typeof";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.array.concat.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.object.assign.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.object.keys.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.object.to-string.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/web.dom-collections.for-each.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.array.index-of.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.regexp.exec.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.string.split.js";
import { getUrlQuery as H, getMobileSystem as le } from "../../../../../@mx_fsp-mweb-utils@0.125.0/node_modules/@mx/fsp-mweb-utils/dist/index.esm.js";
import b from "../../../../../@mx_fsp-mweb-env@0.125.0/node_modules/@mx/fsp-mweb-env/dist/index.esm.js";
import { dcepAppConfig as q } from "../../../../../@mx_fsp-mweb-dcep-config@0.125.0/node_modules/@mx/fsp-mweb-dcep-config/dist/index.esm.js";
import { openPage as Y } from "../../../../../@mx_fsp-mweb-bridge@0.125.0/node_modules/@mx/fsp-mweb-bridge/dist/index.esm.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.array.find.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.object.define-property.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.array.map.js";
import se from "../../../../../@mx_fsp-mweb-request@0.125.0/node_modules/@mx/fsp-mweb-request/dist/index.esm.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.number.constructor.js";
function S() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  S = function S() {
    return n;
  };
  var n = {},
    o = Object.prototype,
    a = o.hasOwnProperty,
    t = typeof Symbol == "function" ? Symbol : {},
    s = t.iterator || "@@iterator",
    c = t.asyncIterator || "@@asyncIterator",
    d = t.toStringTag || "@@toStringTag";
  function u(r, e, l) {
    return Object.defineProperty(r, e, {
      value: l,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), r[e];
  }
  try {
    u({}, "");
  } catch (_unused) {
    u = function u(e, l, h) {
      return e[l] = h;
    };
  }
  function f(r, e, l, h) {
    var i = e && e.prototype instanceof g ? e : g,
      y = Object.create(i.prototype),
      O = new X(h || []);
    return y._invoke = /* @__PURE__ */function (I, W, w) {
      var E = "suspendedStart";
      return function (j, ee) {
        if (E === "executing") throw new Error("Generator is already running");
        if (E === "completed") {
          if (j === "throw") throw ee;
          return x();
        }
        for (w.method = j, w.arg = ee;;) {
          var re = w.delegate;
          if (re) {
            var z = M(re, w);
            if (z) {
              if (z === p) continue;
              return z;
            }
          }
          if (w.method === "next") w.sent = w._sent = w.arg;else if (w.method === "throw") {
            if (E === "suspendedStart") throw E = "completed", w.arg;
            w.dispatchException(w.arg);
          } else w.method === "return" && w.abrupt("return", w.arg);
          E = "executing";
          var L = v(I, W, w);
          if (L.type === "normal") {
            if (E = w.done ? "completed" : "suspendedYield", L.arg === p) continue;
            return {
              value: L.arg,
              done: w.done
            };
          }
          L.type === "throw" && (E = "completed", w.method = "throw", w.arg = L.arg);
        }
      };
    }(r, l, O), y;
  }
  function v(r, e, l) {
    try {
      return {
        type: "normal",
        arg: r.call(e, l)
      };
    } catch (h) {
      return {
        type: "throw",
        arg: h
      };
    }
  }
  n.wrap = f;
  var p = {};
  function g() {}
  function k() {}
  function A() {}
  var R = {};
  u(R, s, function () {
    return this;
  });
  var C = Object.getPrototypeOf,
    m = C && C(C(K([])));
  m && m !== o && a.call(m, s) && (R = m);
  var T = A.prototype = g.prototype = Object.create(R);
  function F(r) {
    ["next", "throw", "return"].forEach(function (e) {
      u(r, e, function (l) {
        return this._invoke(e, l);
      });
    });
  }
  function _(r, e) {
    function l(i, y, O, I) {
      var W = v(r[i], r, y);
      if (W.type !== "throw") {
        var w = W.arg,
          E = w.value;
        return E && _typeof(E) == "object" && a.call(E, "__await") ? e.resolve(E.__await).then(function (j) {
          l("next", j, O, I);
        }, function (j) {
          l("throw", j, O, I);
        }) : e.resolve(E).then(function (j) {
          w.value = j, O(w);
        }, function (j) {
          return l("throw", j, O, I);
        });
      }
      I(W.arg);
    }
    var h;
    this._invoke = function (i, y) {
      function O() {
        return new e(function (I, W) {
          l(i, y, I, W);
        });
      }
      return h = h ? h.then(O, O) : O();
    };
  }
  function M(r, e) {
    var l = r.iterator[e.method];
    if (l === void 0) {
      if (e.delegate = null, e.method === "throw") {
        if (r.iterator.return && (e.method = "return", e.arg = void 0, M(r, e), e.method === "throw")) return p;
        e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return p;
    }
    var h = v(l, r.iterator, e.arg);
    if (h.type === "throw") return e.method = "throw", e.arg = h.arg, e.delegate = null, p;
    var i = h.arg;
    return i ? i.done ? (e[r.resultName] = i.value, e.next = r.nextLoc, e.method !== "return" && (e.method = "next", e.arg = void 0), e.delegate = null, p) : i : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, p);
  }
  function ue(r) {
    var e = {
      tryLoc: r[0]
    };
    1 in r && (e.catchLoc = r[1]), 2 in r && (e.finallyLoc = r[2], e.afterLoc = r[3]), this.tryEntries.push(e);
  }
  function $(r) {
    var e = r.completion || {};
    e.type = "normal", delete e.arg, r.completion = e;
  }
  function X(r) {
    this.tryEntries = [{
      tryLoc: "root"
    }], r.forEach(ue, this), this.reset(!0);
  }
  function K(r) {
    if (r) {
      var e = r[s];
      if (e) return e.call(r);
      if (typeof r.next == "function") return r;
      if (!isNaN(r.length)) {
        var l = -1,
          h = function i() {
            for (; ++l < r.length;) if (a.call(r, l)) return i.value = r[l], i.done = !1, i;
            return i.value = void 0, i.done = !0, i;
          };
        return h.next = h;
      }
    }
    return {
      next: x
    };
  }
  function x() {
    return {
      value: void 0,
      done: !0
    };
  }
  return k.prototype = A, u(T, "constructor", A), u(A, "constructor", k), k.displayName = u(A, d, "GeneratorFunction"), n.isGeneratorFunction = function (r) {
    var e = typeof r == "function" && r.constructor;
    return !!e && (e === k || (e.displayName || e.name) === "GeneratorFunction");
  }, n.mark = function (r) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(r, A) : (r.__proto__ = A, u(r, d, "GeneratorFunction")), r.prototype = Object.create(T), r;
  }, n.awrap = function (r) {
    return {
      __await: r
    };
  }, F(_.prototype), u(_.prototype, c, function () {
    return this;
  }), n.AsyncIterator = _, n.async = function (r, e, l, h, i) {
    i === void 0 && (i = Promise);
    var y = new _(f(r, e, l, h), i);
    return n.isGeneratorFunction(e) ? y : y.next().then(function (O) {
      return O.done ? O.value : y.next();
    });
  }, F(T), u(T, d, "Generator"), u(T, s, function () {
    return this;
  }), u(T, "toString", function () {
    return "[object Generator]";
  }), n.keys = function (r) {
    var e = [];
    for (var l in r) e.push(l);
    return e.reverse(), function h() {
      for (; e.length;) {
        var i = e.pop();
        if (i in r) return h.value = i, h.done = !1, h;
      }
      return h.done = !0, h;
    };
  }, n.values = K, X.prototype = {
    constructor: X,
    reset: function reset(r) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach($), !r) for (var e in this) e.charAt(0) === "t" && a.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
    },
    stop: function stop() {
      this.done = !0;
      var r = this.tryEntries[0].completion;
      if (r.type === "throw") throw r.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(r) {
      if (this.done) throw r;
      var e = this;
      function l(W, w) {
        return y.type = "throw", y.arg = r, e.next = W, w && (e.method = "next", e.arg = void 0), !!w;
      }
      for (var h = this.tryEntries.length - 1; h >= 0; --h) {
        var i = this.tryEntries[h],
          y = i.completion;
        if (i.tryLoc === "root") return l("end");
        if (i.tryLoc <= this.prev) {
          var O = a.call(i, "catchLoc"),
            I = a.call(i, "finallyLoc");
          if (O && I) {
            if (this.prev < i.catchLoc) return l(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return l(i.finallyLoc);
          } else if (O) {
            if (this.prev < i.catchLoc) return l(i.catchLoc, !0);
          } else {
            if (!I) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return l(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(r, e) {
      for (var l = this.tryEntries.length - 1; l >= 0; --l) {
        var h = this.tryEntries[l];
        if (h.tryLoc <= this.prev && a.call(h, "finallyLoc") && this.prev < h.finallyLoc) {
          var i = h;
          break;
        }
      }
      i && (r === "break" || r === "continue") && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var y = i ? i.completion : {};
      return y.type = r, y.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, p) : this.complete(y);
    },
    complete: function complete(r, e) {
      if (r.type === "throw") throw r.arg;
      return r.type === "break" || r.type === "continue" ? this.next = r.arg : r.type === "return" ? (this.rval = this.arg = r.arg, this.method = "return", this.next = "end") : r.type === "normal" && e && (this.next = e), p;
    },
    finish: function finish(r) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var l = this.tryEntries[e];
        if (l.finallyLoc === r) return this.complete(l.completion, l.afterLoc), $(l), p;
      }
    },
    catch: function _catch(r) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var l = this.tryEntries[e];
        if (l.tryLoc === r) {
          var h = l.completion;
          if (h.type === "throw") {
            var i = h.arg;
            $(l);
          }
          return i;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(r, e, l) {
      return this.delegate = {
        iterator: K(r),
        resultName: e,
        nextLoc: l
      }, this.method === "next" && (this.arg = void 0), p;
    }
  }, n;
}
function te(n, o) {
  if (!(n instanceof o)) throw new TypeError("Cannot call a class as a function");
}
function pe(n, o) {
  for (var a = 0; a < o.length; a++) {
    var t = o[a];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(n, t.key, t);
  }
}
function oe(n, o, a) {
  return o && pe(n.prototype, o), Object.defineProperty(n, "prototype", {
    writable: !1
  }), n;
}
function fe(n, o) {
  if (typeof o != "function" && o !== null) throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(o && o.prototype, {
    constructor: {
      value: n,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(n, "prototype", {
    writable: !1
  }), o && D(n, o);
}
function B(n) {
  return B = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, B(n);
}
function D(n, o) {
  return D = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, s) {
    return t.__proto__ = s, t;
  }, D(n, o);
}
function ae() {
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused2) {
    return !1;
  }
}
function J(n, o, a) {
  return ae() ? J = Reflect.construct.bind() : J = function J(s, c, d) {
    var u = [null];
    u.push.apply(u, c);
    var f = Function.bind.apply(s, u),
      v = new f();
    return d && D(v, d.prototype), v;
  }, J.apply(null, arguments);
}
function de(n) {
  return Function.toString.call(n).indexOf("[native code]") !== -1;
}
function V(n) {
  var o = typeof Map == "function" ? /* @__PURE__ */new Map() : void 0;
  return V = function V(t) {
    if (t === null || !de(t)) return t;
    if (typeof t != "function") throw new TypeError("Super expression must either be null or a function");
    if (_typeof(o) < "u") {
      if (o.has(t)) return o.get(t);
      o.set(t, s);
    }
    function s() {
      return J(t, arguments, B(this).constructor);
    }
    return s.prototype = Object.create(t.prototype, {
      constructor: {
        value: s,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), D(s, t);
  }, V(n);
}
function he(n) {
  if (n === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function we(n, o) {
  if (o && (_typeof(o) == "object" || typeof o == "function")) return o;
  if (o !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return he(n);
}
function ve(n) {
  var o = ae();
  return function () {
    var t = B(n),
      s;
    if (o) {
      var c = B(this).constructor;
      s = Reflect.construct(t, arguments, c);
    } else s = t.apply(this, arguments);
    return we(this, s);
  };
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function N(n, o, a, t) {
  function s(c) {
    return c instanceof a ? c : new a(function (d) {
      d(c);
    });
  }
  return new (a || (a = Promise))(function (c, d) {
    function u(p) {
      try {
        v(t.next(p));
      } catch (g) {
        d(g);
      }
    }
    function f(p) {
      try {
        v(t.throw(p));
      } catch (g) {
        d(g);
      }
    }
    function v(p) {
      p.done ? c(p.value) : s(p.value).then(u, f);
    }
    v((t = t.apply(n, [])).next());
  });
}
var ne = H(),
  G = ne && ne.Swimlane || "",
  P = "https://ecny.meituan.com",
  Z = "https://npay.meituan.com",
  Q = location.protocol;
b.runtime === 1 && (P = "".concat(Q, "//stable.pay.st.sankuai.com"), Z = "https://stable-pay.st.meituan.com");
b.runtime === 2 && (P = G ? "".concat(Q, "//").concat(G, "-sl-stable.pay.test.sankuai.com") : "".concat(Q, "//stable.pay.test.sankuai.com"), Z = G ? "".concat(Q, "//").concat(G, "-sl-cashier.qa.pay.test.sankuai.com") : "http://cashier.qa.pay.test.sankuai.com");
var ie = {
  dealReverseBindWalletRespInfoApi: "".concat(P, "/ecny/wallet/user/dealReverseBindWalletRespInfo"),
  queryReverseBindWalletInfoApi: "".concat(P, "/ecny/wallet/user/queryReverseBindWalletInfo"),
  getPullEcnyAppUpgradeWalletParamsApi: "".concat(P, "/ecny/walletapp/user/getPullEcnyAppUpgradeWalletParams"),
  getPullEcnyAppUpgradeWalletResultApi: "".concat(P, "/ecny/walletapp/user/getPullEcnyAppUpgradeWalletResult"),
  openoneclickpayApi: "".concat(Z, "/api/wallet/oneclickpay/openoneclickpay"),
  walletTopApi: "".concat(P, "/ecny/walletapp/user/walletTop")
};
function me(n) {
  var o = {
    exports: {}
  };
  return n(o, o.exports), o.exports;
}
var ye = me(function (n, o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), o.objectToQuery = void 0;
    function a(t) {
      return Object.keys(t).map(function (s) {
        return s + "=" + encodeURIComponent(t[s] === void 0 ? "" : t[s]);
      }).join("&");
    }
    o.objectToQuery = a;
  }),
  U;
(function (n) {
  n[n.TOAST = 1] = "TOAST", n[n.MODAL = 2] = "MODAL", n[n.MODAL_EXIT = 3] = "MODAL_EXIT", n[n.EXIT = 4] = "EXIT";
})(U || (U = {}));
var ge = /* @__PURE__ */function (n) {
    fe(a, n);
    var o = ve(a);
    function a(t, s, c) {
      var d;
      return te(this, a), d = o.call(this, t), d.level = s, d.code = c, d;
    }
    return oe(a);
  }(/* @__PURE__ */V(Error)),
  Oe = ["401", "402", "403", "404", "405", "406", "4001", "100001", "999999"];
function be(n, o) {
  var a = Oe.find(function (t) {
    return t === "".concat(n.code);
  });
  if (a != null && a.length) {
    sessionStorage.setItem("login", "1");
    return;
  }
  if (!o) switch (n.level) {
    case U.TOAST:
      break;
    case U.MODAL_EXIT:
    case U.EXIT:
      break;
    case U.MODAL:
      break;
  }
}
function ce(n) {
  return N(this, void 0, void 0, /* @__PURE__ */S().mark(function o() {
    var a, t;
    return S().wrap(function (c) {
      for (;;) switch (c.prev = c.next) {
        case 0:
          return n.showToast, c.prev = 1, c.next = 4, se(Object.assign(Object.assign({}, n), {
            transformRequest: function transformRequest(u) {
              return u = Object.assign(Object.assign({}, b.commonParams), u), ye.objectToQuery(u);
            }
          }));
        case 4:
          if (a = c.sent, n.showToast, !a.error) {
            c.next = 9;
            break;
          }
          throw t = a.error, new ge(t.message, t.level, t.code);
        case 9:
          return c.abrupt("return", a.data);
        case 12:
          throw c.prev = 12, c.t0 = c.catch(1), n.showToast, be(c.t0, n.noShowErrorToast), c.t0;
        case 17:
          return c.abrupt("return", null);
        case 18:
        case "end":
          return c.stop();
      }
    }, o, null, [[1, 12]]);
  }));
}
var Ee = function Ee(o) {
    var a = {
      url: ie.queryReverseBindWalletInfoApi,
      method: "post",
      data: o
    };
    return ce(a);
  },
  Ae = function Ae(o) {
    var a = {
      url: ie.dealReverseBindWalletRespInfoApi,
      method: "post",
      data: o
    };
    return ce(a);
  },
  qe = /* @__PURE__ */function () {
    function n(o) {
      te(this, n), this.config = o || {};
    }
    return oe(n, [{
      key: "jumpToDcepApp",
      value: function value() {
        var a = this,
          t = q.appId.commonLink,
          s = b.isIOS ? "iOS" : "Android";
        Y(t, function (c) {
          a.downloadApp(), window.Owl && window.Owl.addError && window.Owl.addError({
            name: "打开数币App失败-".concat(s),
            msg: "err:".concat(JSON.stringify(c), ";url:").concat(location.href)
          }, {
            level: "warn"
          }), b.isIOS && KNB.ready(function () {
            KNB.isInstalledApp({
              scheme: "dcep://",
              package: "cn.gov.pbc.dcep",
              success: function success(u) {
                u.installed ? window.Owl && window.Owl.addError && window.Owl.addError({
                  name: "打开数币App失败且检测已经安装数币App-iOS",
                  msg: "err:".concat(JSON.stringify(c), ";url:").concat(location.href)
                }, {
                  level: "info"
                }) : window.Owl && window.Owl.addError && window.Owl.addError({
                  name: "打开数币App失败且检测未安装数字人民币App-iOS",
                  msg: "err:".concat(JSON.stringify(c), ";url:").concat(location.href)
                }, {
                  level: "info"
                });
              }
            });
          });
        });
      }
    }, {
      key: "downloadApp",
      value: function value() {
        var a = this,
          t = le() || "android",
          s = q.downloadUrl.androidMarket,
          c = t === "iphone" ? q.downloadUrl.iosUrl : "".concat(s, "&openInApp=2&_new_task=1"),
          d = b.isIOS ? "iOS" : "Android";
        Y(c, function (u) {
          a.config.handleDownloadEcnyAppFailCallback && a.config.handleDownloadEcnyAppFailCallback(), window.Owl && window.Owl.addError && window.Owl.addError({
            name: "打开数币App下载页面失败-".concat(d),
            msg: "err:".concat(JSON.stringify(u), ";url:").concat(location.href)
          }, {
            level: "error"
          });
        });
      }
    }, {
      key: "addWallet",
      value: function value() {
        var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "",
          t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0,
          s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        return N(this, void 0, void 0, /* @__PURE__ */S().mark(function c() {
          var d = this,
            u,
            f,
            v,
            p,
            g,
            k,
            A,
            R;
          return S().wrap(function (m) {
            for (;;) switch (m.prev = m.next) {
              case 0:
                return m.prev = 0, m.next = 3, this.queryReverseBindWalletInfo(a, t, s);
              case 3:
                if (u = m.sent, u) {
                  m.next = 7;
                  break;
                }
                return this.jumpToDcepApp(), m.abrupt("return");
              case 7:
                f = u.sign, v = u.app_id, p = u.inst_no, g = u.extra_info, k = u.sign_info, A = u.biz_type, R = "".concat(q.bindWalletScheme, "?appId=").concat(encodeURIComponent(v), "&extraInfo=").concat(encodeURIComponent(g), "&biz=").concat(encodeURIComponent(A), "&instNo=").concat(encodeURIComponent(p), "&signInfo=").concat(encodeURIComponent(k), "&sign=").concat(encodeURIComponent(f)), Y(R, function (T) {
                  d.jumpToDcepApp();
                  var F = b.isIOS ? "iOS" : "Android";
                  window.Owl && window.Owl.addError && window.Owl.addError({
                    name: "一键反绑-打开数币App失败-".concat(F),
                    msg: "err:".concat(JSON.stringify(T), "url:").concat(location.href)
                  }, {
                    level: "warn"
                  }), console.log("env.isIOS", b.isIOS), b.isIOS && KNB.ready(function () {
                    KNB.isInstalledApp({
                      scheme: "dcep://",
                      package: "cn.gov.pbc.dcep",
                      success: function success(M) {
                        M.installed ? window.Owl && window.Owl.addError && window.Owl.addError({
                          name: "一键反绑-打开数币App失败且检测已经安装数币App-iOS",
                          msg: "err:".concat(JSON.stringify(T), ";url:").concat(location.href)
                        }, {
                          level: "info"
                        }) : window.Owl && window.Owl.addError && window.Owl.addError({
                          name: "一键反绑-打开数币App失败且检测未安装数字人民币App-iOS",
                          msg: "err:".concat(JSON.stringify(T), ";url:").concat(location.href)
                        }, {
                          level: "info"
                        });
                      }
                    });
                  });
                }), m.next = 15;
                break;
              case 12:
                m.prev = 12, m.t0 = m.catch(0), window.Owl && window.Owl.addError && window.Owl.addError({
                  name: "一键反绑失败,走到catch逻辑",
                  msg: "err:".concat(JSON.stringify(m.t0), ";url:").concat(location.href)
                }, {
                  level: "error"
                });
              case 15:
              case "end":
                return m.stop();
            }
          }, c, this, [[0, 12]]);
        }));
      }
    }, {
      key: "queryReverseBindWalletInfo",
      value: function value(a, t, s) {
        return N(this, void 0, void 0, /* @__PURE__ */S().mark(function c() {
          var d, u, f;
          return S().wrap(function (p) {
            for (;;) switch (p.prev = p.next) {
              case 0:
                return p.prev = 0, d = this.genReturnUrl(t, s), u = {
                  return_url: d
                }, a && (u.payType = a), p.next = 6, Ee(u);
              case 6:
                return f = p.sent, p.abrupt("return", f);
              case 10:
                return p.prev = 10, p.t0 = p.catch(0), window.Owl && window.Owl.addError && window.Owl.addError({
                  name: "一键反绑获取参数接口异常",
                  msg: "err:".concat(JSON.stringify(p.t0), ";url:").concat(location.href)
                }, {
                  level: "error"
                }), p.abrupt("return", "");
              case 14:
              case "end":
                return p.stop();
            }
          }, c, this, [[0, 10]]);
        }));
      }
    }, {
      key: "genReturnUrl",
      value: function value(a, t) {
        var s = window.location.href,
          c = t ? Object.assign(Object.assign({}, b.businessParams), {
            routerPath: t
          }) : b.businessParams || {},
          d = Object.keys(c),
          u = "openFromEcny=true";
        d.forEach(function (R) {
          c[R] && (u = "".concat(u, "&").concat(R, "=").concat(c[R]));
        });
        var f;
        if (s.indexOf("#") !== -1) {
          var v = s.split("#/") || [],
            p = v[0].split("?")[0];
          f = v[1] && a ? "".concat(p, "?").concat(u, "#/").concat(v[1]) : "".concat(p, "?").concat(u);
        } else f = s.indexOf("?") === -1 ? "".concat(s, "?").concat(u) : "".concat(s.split("?")[0], "?").concat(u);
        var g = "imeituan://web?url=";
        b.isInMeituan && (g = "imeituan://web?url="), b.isInWaimai && (g = "meituanwaimai://waimai.meituan.com/browser?inner_url="), b.isInDianping && (g = "dianping://web?url=");
        var k = encodeURIComponent(f),
          A = b.isInWaimai && b.isAndroid ? "".concat(g).concat(encodeURIComponent(k), "&needSpliceParams=true") : "".concat(g).concat(k, "&needSpliceParams=true");
        return A;
      }
    }, {
      key: "handleAddWalletEcnyAppCallback",
      value: function value() {
        return N(this, void 0, void 0, /* @__PURE__ */S().mark(function a() {
          var t, s, c, d;
          return S().wrap(function (f) {
            for (;;) switch (f.prev = f.next) {
              case 0:
                if (this.isFromEcnyApp()) {
                  f.next = 2;
                  break;
                }
                return f.abrupt("return");
              case 2:
                return t = H(), s = t && t.sign, c = t && t.signInfo, f.next = 7, this.dealReverseBindWalletRespInfo(decodeURIComponent(s), decodeURIComponent(c));
              case 7:
                d = f.sent, !d || d.push_code.toUpperCase() !== "OK" ? this.config.handleAddWalletFailCallback && this.config.handleAddWalletFailCallback(d) : this.config.handleAddWalletSuccessCallback && this.config.handleAddWalletSuccessCallback(d);
              case 9:
              case "end":
                return f.stop();
            }
          }, a, this);
        }));
      }
    }, {
      key: "isFromEcnyApp",
      value: function value() {
        var a = H(),
          t = a && a.openFromEcny;
        return !!t;
      }
    }, {
      key: "dealReverseBindWalletRespInfo",
      value: function value(a, t) {
        return N(this, void 0, void 0, /* @__PURE__ */S().mark(function s() {
          var c, d;
          return S().wrap(function (f) {
            for (;;) switch (f.prev = f.next) {
              case 0:
                return f.prev = 0, c = {
                  sign: a,
                  signInfo: t
                }, f.next = 4, Ae(c);
              case 4:
                return d = f.sent, f.abrupt("return", d);
              case 8:
                return f.prev = 8, f.t0 = f.catch(0), window.Owl && window.Owl.addError && window.Owl.addError({
                  name: "一键反绑结果查询接口异常",
                  msg: "err:".concat(JSON.stringify(f.t0), ";url:").concat(location.href)
                }, {
                  level: "error"
                }), f.abrupt("return", "");
              case 12:
              case "end":
                return f.stop();
            }
          }, s, null, [[0, 8]]);
        }));
      }
    }]), n;
  }();
export { qe as AddWalletSdk };
